import React from 'react';

import images from '../libs/images';
import consts from '../libs/consts';

export default function Image({ src, className=[], style={}, onClick=()=>{} }) {

    return (
        <img 
            onClick={onClick}
            className={`${consts.animationFadeIn} ${className?.join(" ")}`} 
            src={src} 
            alt={consts.imgAlt}
            style={style}
        />
    )    
}